import { createSelector } from '@ngrx/store';
import { selectStatusState } from '../reducers';

/**
 * Select the loading status.
 */
export const selectLoadingStatus = createSelector(
  selectStatusState,
  (state) => state.loading,
);

export const selectIsEditing = createSelector(
  selectStatusState,
  (state) => state.editing,
);

export const selectShowAcknowledgement = createSelector(
  selectStatusState,
  (state) => state.showAcknowledgement,
);

export const selectShowNotification = createSelector(
  selectStatusState,
  (state) => state.showNotification,
);

export const selectAcknowledgement = createSelector(
  selectStatusState,
  (state) => state.acknowledgement,
);

export const selectNotification = createSelector(
  selectStatusState,
  (state) => state.notification,
);

export const selectDisplayForPrint = createSelector(
  selectStatusState,
  (state) => state.displayForPrint,
);
